export default __webpack_public_path__ + "static/media/w4.f9ef97a0.jpg";